<template>
  <div></div>
</template>

<script>
export default {
  name: "VueMode",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped></style>
